import React, { useState } from 'react';
import { Modal } from './Modal';
import { PrivacyPolicy } from './PrivacyPolicy';
import { TermsOfService } from './TermsOfService';
export function Footer() {
  const [isPrivacyOpen, setIsPrivacyOpen] = useState(false);
  const [isTermsOpen, setIsTermsOpen] = useState(false);
  return <footer className="bg-amber-900 text-amber-100 py-6" data-id="element-130">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 text-center" data-id="element-131">
        <p className="text-sm mb-4" data-id="element-132">
          © 2024 Método Milhojas Perfecta by Stella Pereira. Todos los derechos
          reservados.
        </p>
        <div className="flex justify-center space-x-4 text-xs" data-id="element-133">
          <button onClick={() => setIsPrivacyOpen(true)} className="text-amber-200 hover:text-white underline transition-colors" data-id="element-134">
            Política de Privacidad
          </button>
          <button onClick={() => setIsTermsOpen(true)} className="text-amber-200 hover:text-white underline transition-colors" data-id="element-135">
            Términos y Condiciones
          </button>
        </div>
      </div>
      {/* Privacy Policy Modal */}
      <Modal isOpen={isPrivacyOpen} onClose={() => setIsPrivacyOpen(false)} title="Política de Privacidad" data-id="element-136">
        <PrivacyPolicy data-id="element-137" />
      </Modal>
      {/* Terms of Service Modal */}
      <Modal isOpen={isTermsOpen} onClose={() => setIsTermsOpen(false)} title="Términos y Condiciones" data-id="element-138">
        <TermsOfService data-id="element-139" />
      </Modal>
    </footer>;
}